import { createContext } from 'react';
import utils from '../../utils';

export type StepsContextProps = {
  container: React.MutableRefObject<HTMLElement | Window>;
  setContainer: (element: HTMLElement) => void;
  setShouldScroll: (shouldScroll: boolean) => void;
  resetContainer: () => void;
};

export default createContext<StepsContextProps>({
  container: null,
  setContainer: utils.noop,
  setShouldScroll: utils.noop,
  resetContainer: utils.noop,
});
